import React from 'react';

import CalendarIcon from 'Assets/icons/calendar.svg';
import SearchIcon from 'Assets/icons/search.svg';

// Empty state for the My Events table. Two variants, because the table reaches zero rows two
// different ways and the useful thing to say differs completely.
//
//   empty     — the user belongs to no projects at all. Only an administrator can change that.
//   filtered  — the search box excludes everything. The projects exist; the view is narrow.
export const VARIANT_EMPTY = 'empty';
export const VARIANT_FILTERED = 'filtered';

const ICONS = {
    [VARIANT_EMPTY]: CalendarIcon,
    [VARIANT_FILTERED]: SearchIcon,
};

export default function MyEventsEmptyState({ variant = VARIANT_EMPTY }) {
    const Icon = ICONS[variant] || ICONS[VARIANT_EMPTY];

    const heading = {
        [VARIANT_EMPTY]: $t('You are not a member of any projects yet'),
        [VARIANT_FILTERED]: $t('No projects match your search'),
    }[variant];

    const body = {
        [VARIANT_EMPTY]: $t('Contact your organisation administrator to be added to a project. Once you are, it appears here.'),
        [VARIANT_FILTERED]: $t('None of your projects match that search. Clear the search box to see them all.'),
    }[variant];

    return (
        // Normal flow with vertical padding rather than `tw-absolute tw-inset-0`: this replaces a
        // table inside `.table__card`, which has no height of its own, so absolute positioning
        // would collapse the card to nothing.
        //
        // role="status" so a screen reader is told the table came back empty. Without it the only
        // signal is a silent swap of the table for this block, which announces nothing.
        <div role="status" className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-py-12 tw-px-6">
            <div className="tw-flex tw-items-center tw-justify-center tw-h-14 tw-w-14 tw-rounded-full tw-bg-background tw-mb-4">
                <Icon className="tw-h-6 tw-w-6 tw-text-charcoal-50" aria-hidden="true" />
            </div>
            <h4 className="tw-text-base tw-font-semibold tw-text-charcoal tw-mb-1">{heading}</h4>
            <p className="tw-text-sm tw-text-charcoal-75 tw-max-w-sm">{body}</p>
        </div>
    );
}
